import axios from 'axios';
require('dotenv').config();

const api = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3333' : 'https://apiousadoresolve.herokuapp.com',
    //timeout: 5000,
  });

export default api